import { useState } from 'react';
import { ChevronRight, Plus } from '@/components/ui/icons';
import type { Task } from '@shared/types';
import { useDbShallow } from '@/lib/store';
import { fieldsForList } from '@/lib/hierarchy';
import { CustomFieldCell } from '@/components/fields/CustomField';
import { FIELD_TYPE_ICONS } from '@/components/ui/Icon';
import { openFieldEditor } from '@/views/FieldsPanel';

/** Custom fields section ("Fields"). */
export function TaskFields({ task }: { task: Task }) {
  const fields = useDbShallow((db) => fieldsForList(db, task.listId));
  const [open, setOpen] = useState(true);
  const [hideEmpty, setHideEmpty] = useState(false);
  const shown = hideEmpty ? fields.filter((f) => task.customFields[f.id] !== undefined) : fields;
  return (
    <section className="tm-section">
      <div className="tm-section-head">
        <button className={`tm-caret ${open ? 'open' : ''}`} onClick={() => setOpen(!open)}>
          <ChevronRight size={14} />
        </button>
        <span className="tm-section-title">Fields</span>
        <span className="spacer" />
        {fields.length > 0 && (
          <button className="btn sm" onClick={() => setHideEmpty(!hideEmpty)}>
            {hideEmpty ? 'Show empty' : 'Hide empty'}
          </button>
        )}
        <button className="icon-btn sm" title="Create field" onClick={() => openFieldEditor({ type: 'list', id: task.listId })}>
          <Plus size={15} />
        </button>
      </div>
      {open && (
        <div className="tm-fields">
          {shown.map((f) => {
            const I = FIELD_TYPE_ICONS[f.type];
            return (
              <div key={f.id} className="tm-field-row">
                <div className="tm-field-name">
                  <I size={14} className="faint" />
                  <span className="truncate">{f.name}</span>
                </div>
                <div className="tm-field-value">
                  <CustomFieldCell task={task} field={f} />
                </div>
              </div>
            );
          })}
          {fields.length === 0 && (
            <button className="tm-field-empty" onClick={() => openFieldEditor({ type: 'list', id: task.listId })}>
              <Plus size={14} /> Create a field on this List
            </button>
          )}
        </div>
      )}
    </section>
  );
}
